import { Form, type FormItemProps, Switch as AntdSwitch, type SwitchProps as AntdSwitchProps } from 'antd';

import type { Ii18nLabel } from '@/types/common';

import { getFormItemLabel } from './utils';

interface InputProps extends FormItemProps, AntdSwitchProps, Ii18nLabel {
  name: string;
  children: any;
}

export const Switch = ({ name, label, i18nLabel, rules, disabled }: InputProps) => {
  const fieldLabel = getFormItemLabel(i18nLabel, label);

  return (
    <Form.Item name={name} label={fieldLabel} rules={rules} valuePropName="checked">
      <AntdSwitch disabled={disabled} />
    </Form.Item>
  );
};
